import { cn } from "./cn";

/** The shared shell for every text-like control: input, textarea, picker. */
export const controlClassName = cn(
  "w-full h-(--control-h) min-h-(--control-min-h) rounded-lg bg-sunken px-3.5 text-body text-fg",
  "placeholder:text-fg-subtle",
  "focus-visible:outline-2 focus-visible:outline-offset-0 focus-visible:outline-focus",
  "aria-[invalid=true]:outline-[1.5px] aria-[invalid=true]:outline-offset-0 aria-[invalid=true]:outline-error",
  "disabled:cursor-not-allowed disabled:text-fg-disabled",
);
